export const ChartHeight = 400;
export const ChartSoilHeight = 460;
export const ChartHeightMobile = 240;
export const ChartYAxisWidth = 40;
export const ChartDotRadius = 5;

export const ChartColorsMap = {
  temperature: '#FA8C16',
  temperatureCompared: '#ffc069',
  temperatureMax: '#FFAB2C',
  temperatureMin: '#005EFF',

  gdd: '#FA541C',
  gddCompared: '#ffc069',

  bbch: '#fa541c',
  bbchCompared: '#ffc069',
  bbchBarCompared: 'rgba(47,84,235)',
  bbchBarActive: '#93BD43',
  bbchBarActiveCompared: '#7CB305',

  leafArea: '#237804',
  leafAreaCompared: '#95de64',

  ndvi: '#5b8c00',
  ndviCompared: '#acda38',

  leafNDVI: '#5b8c00',
  leafNDVICompared: '#acda38',

  soilNDVI: '#5b8c00',
  soilNDVICompared: '#acda38',

  humidity: '#2F54EB',
  humidityCompared: '#69c0ff',

  dew: '#2F54EB',
  dewCompared: '#69c0ff',

  rain: '#bae7ff',
  rainActive: '#90d6fb',

  soilHumidity: '#2F54EB',
  soilHumidityCompared: '#69c0ff',

  soilTemperature: '#FA8C16',
  soilTemperatureCompared: '#ffc069',

  soil: '#69C0FF',
  soilCompared: '#40A9FF',

  salinity: '#088b9c',
  salinityCompared: '#0bb7cd',

  grid: 'var(--neutral-8)',
  brush: '#BCD885',
};

export const ChartDeepColorsMap = {
  deep10: '#FFA39E',
  deep20: '#FFD8BF',
  deep30: '#FFD591',
  deep40: '#B7EB8F',
  deep50: '#87E8DE',
  deep60: '#BAE7FF',
  deep70: '#ADC6FF',
  deep80: '#D3ADF7',
  deep90: '#FFADD2',
};

export const ChartDeepLineColorsMap = {
  deep10: '#FF7875',
  deep20: '#FF9C6E',
  deep30: '#FFC069',
  deep40: '#D3F261',
  deep50: '#5CDBD3',
  deep60: '#69C0FF',
  deep70: '#85A5FF',
  deep80: '#B37FEB',
  deep90: '#FF85C0',
};

export const ChartDeepOptions = [
  { value: '10', disabled: false, style: { color: ChartDeepColorsMap.deep10 }, color: ChartDeepLineColorsMap.deep10 },
  { value: '20', disabled: false, style: { color: ChartDeepColorsMap.deep20 }, color: ChartDeepLineColorsMap.deep20 },
  { value: '30', disabled: false, style: { color: ChartDeepColorsMap.deep30 }, color: ChartDeepLineColorsMap.deep30 },
  { value: '40', disabled: false, style: { color: ChartDeepColorsMap.deep40 }, color: ChartDeepLineColorsMap.deep40 },
  { value: '50', disabled: false, style: { color: ChartDeepColorsMap.deep50 }, color: ChartDeepLineColorsMap.deep50 },
  { value: '60', disabled: false, style: { color: ChartDeepColorsMap.deep60 }, color: ChartDeepLineColorsMap.deep60 },
  { value: '70', disabled: false, style: { color: ChartDeepColorsMap.deep70 }, color: ChartDeepLineColorsMap.deep70 },
  { value: '80', disabled: false, style: { color: ChartDeepColorsMap.deep80 }, color: ChartDeepLineColorsMap.deep80 },
  { value: '90', disabled: false, style: { color: ChartDeepColorsMap.deep90 }, color: ChartDeepLineColorsMap.deep90 },
];

export const ChartDefaultOption = {
  value: ChartDeepOptions[0].value,
  color: ChartDeepOptions[0].color,
};

export const KeysCsv = {
  temperature: 'Date,"Min, °C","Max, °C","Mean, °C"',
  humidity: 'Date,"Humidity, %"',
  dew: 'Date,"Dewfall Duration, min"',
  gdd: 'Date,"GDD Daily"',
  ndvi: 'Date,NDVI,Min, Max',
  bbch: 'Date,BBCH,"BBCH description"',
  leafArea: 'Date,"Leaf Area, %"',
  leafNdvi: 'Date,"Leaf NDVI", Min, Max',
  soilNdvi: 'Date,"Soil NDVI", Min, Max',
  rain: 'Date,"Rain, %/h"',
  salinity: 'Date,"Salinity"',
};

export const SOIL_DEPTH_REGEX = /^(soilHumidity|soilTemperature|salinity)_(10|20|30|40|50|60|70|80|90)$/;

export const SENSOR_PREFIXES = ['soilHumidity', 'soilTemperature', 'salinity'];
